import { render } from "./FooterGdb.vue?vue&type=template&id=01ec47bc&scoped=true"
import script from "./FooterGdb.vue?vue&type=script&lang=js"
export * from "./FooterGdb.vue?vue&type=script&lang=js"

import "./FooterGdb.vue?vue&type=style&index=0&id=01ec47bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ec47bc"]])

export default __exports__